import useSearchProducts from './useSearchProducts'
export default useSearchProducts
